module.exports = __webpack_public_path__ + "684a2e06b4051aa078ca79d39eb7394f.png";


//////////////////
// WEBPACK FOOTER
// ./apps/www.relic.com/src/img/main/stat-population.png
// module id = 179
// module chunks = 0